import cn from 'classnames';
import usePoolId from './hooks/usePoolId';
import { PoolInfo } from './components/PoolInfo/PoolInfo';
import { PoolCreators } from './components/PoolCreators/PoolCreators';
import styles from './PoolDetails.module.css';

const PoolDetails = () => {
    const poolId = usePoolId();

    return (
        <div className={cn(styles.container, 'twp')}>
            <header className={styles.infoSection}>
                <PoolInfo poolId={poolId} />
            </header>
            <section className={styles.creatorsSection}>
                <PoolCreators poolId={poolId} />
            </section>
        </div>
    );
};

export default PoolDetails;
